import { TooltipProvider } from '../../ui/tooltip';

export const AddressSummarySkeleton = () => {
  return (
    <TooltipProvider>
      <div className="mx-auto mb-6 w-full max-w-[1500px] rounded-lg border border-muted-50 bg-background shadow-[0_0_10px_rgba(0,0,0,0.1)] dark:border-muted-200">
        <div className="px-4 py-6 sm:px-6">
          {/* AddressProfile skeleton */}
          <div className="mb-6 flex flex-col items-start gap-4 sm:flex-row sm:items-center">
            {/* Blockchain Avatar skeleton */}
            <div className="h-16 w-16 animate-pulse rounded-full bg-muted-200" />

            <div className="flex w-full flex-1 flex-col gap-1">
              {/* Header skeleton */}
              <div className="flex flex-col sm:flex-row sm:justify-between">
                <div className="mb-2 h-8 w-48 animate-pulse rounded bg-muted-200 sm:mb-0" />
                {/* Toolbar skeleton */}
                <div className="flex items-center gap-2">
                  <div className="h-6 w-6 animate-pulse rounded-full bg-muted-200" />
                  <div className="h-6 w-6 animate-pulse rounded-full bg-muted-200" />
                  <div className="h-6 w-6 animate-pulse rounded-full bg-muted-200" />
                  <div className="h-6 w-6 animate-pulse rounded-full bg-muted-200" />
                </div>
              </div>

              {/* Balance skeleton */}
              <div className="h-7 w-32 animate-pulse rounded bg-muted-200" />

              {/* Tags skeleton */}
              <div className="mt-1 flex items-center gap-2">
                <div className="h-5 w-20 animate-pulse rounded bg-muted-200" />
                <div className="h-5 w-16 animate-pulse rounded bg-muted-200" />
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-4 lg:flex-row">
            <div className="lg:max-w-[50%] lg:flex-shrink-0">
              {/* Blockchain Label skeleton */}
              <div className="mb-0.5 h-4 w-24 animate-pulse rounded bg-muted-200" />

              {/* Address Display skeleton */}
              <div className="flex h-9 items-center">
                <div className="h-5 w-96 animate-pulse rounded bg-muted-200" />
                <div className="ml-2 h-6 w-6 animate-pulse rounded-full bg-muted-200" />
                <div className="ml-2 h-6 w-6 animate-pulse rounded-full bg-muted-200" />
              </div>

              {/* Beneficial Owner skeleton */}
              <div className="mt-2 flex flex-row flex-wrap items-center py-2">
                <div className="h-5 w-32 animate-pulse rounded bg-muted-200" />
                <div className="ml-2 h-5 w-24 animate-pulse rounded bg-muted-200" />
              </div>
            </div>

            {/* AddressStats skeleton */}
            <div className="min-w-0 flex-1">
              <div className="grid w-full grid-cols-1 gap-2 sm:grid-cols-3">
                {[...Array(3)].map((_, i) => (
                  <div
                    key={i}
                    className="h-[108px] w-full animate-pulse rounded-lg bg-card p-4"
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </TooltipProvider>
  );
};
